// extracted by mini-css-extract-plugin
export var paragraph = "intro-module--paragraph--1sQTV";